import * as React from "react";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from "source/app/presentation/Shared/Render";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { bookOfMindSpeech } from "../../../Speech/BookOfMindSpeech";
import { PauseOrResumeLink } from "./PauseOrResumeLink";
import * as styles from "../SpeechControls.css";

export function ActiveSpeechControls({ state }: { state: IBookOfMindState }) {
    const isPaused =
        !state.isSpeechActive && state.spokenQuoteIndex !== undefined;

    return (
        <span
            className={StyleClass("bookOfMindSpeechControlsRow", {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "0.75rem",
                width: "100%",
                margin: 0,
                "& > span": {
                    display: "inline-flex",
                    alignItems: "center",
                    margin: 0,
                },
                "& > span > span": {
                    margin: 0,
                },
            })}
        >
            <Render
                id="BookOfMindSpeechControl_previousLink"
                when={state.spokenQuoteIndex || 0 > 0}
            >
                <PreviousQuoteLink />
            </Render>
            <PauseOrResumeLink {...{ state, isPaused }} />
            <Render
                id="BookOfMindSpeechControl_nextLink"
                when={
                    state.spokenQuoteIndex || 0 < state.itemsToSpeak.length - 1
                }
            >
                <NextQuoteLink />
            </Render>
        </span>
    );
}

function PreviousQuoteLink() {
    return (
        <IconWithText
            iconSuffix={EGlyphicon.backward}
            whenClicked={async () =>
                await bookOfMindSpeech.PlayQuoteWithOffsetAsync(-1)
            }
            displayAsBlock={false}
            withClass={styles.controlButton}
        >
            Previous
        </IconWithText>
    );
}

function NextQuoteLink() {
    return (
        <IconWithText
            iconSuffix={EGlyphicon.forward}
            whenClicked={async () =>
                await bookOfMindSpeech.PlayQuoteWithOffsetAsync(1)
            }
            displayAsBlock={false}
            withClass={styles.controlButton}
        >
            Next
        </IconWithText>
    );
}
